<template>
    <section class="tables">
        <div class="row">
            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                    <div class="card-body">
                        <h2 class="card-title">{{ $t('names.customerConsents.name') }}</h2>
                        <p class="card-description">{{ $t('names.customerConsents.description') }}</p>
                        <div class="row">
                            <div class="col-lg-2">
                                <b-form-group :label="$t('forms.dateFrom')" label-for="date-from-input">
                                    <b-form-input type="date" id="date-from-input" v-model="filters.dateFrom" @change="applyFilters"/>
                                </b-form-group>
                            </div>
                            <div class="col-lg-2">
                                <b-form-group :label="$t('forms.dateTo')" label-for="date-to-input">
                                    <b-form-input type="date" id="date-to-input" v-model="filters.dateTo" @change="applyFilters"/>
                                </b-form-group>
                            </div>
                            <div class="col-lg-3">
                                <b-form-group :label="$t('forms.orderType')" label-for="order-type-input">
                                    <b-form-select id="order-type-input" v-model="filters.orderType" :options="orderTypeOptions" @change="applyFilters"/>
                                </b-form-group>
                            </div>
                            <div class="col-lg-3">
                                <b-form-group :label="$t('forms.search')" label-for="search-input">
                                    <b-form-input type="text" id="search-input" :placeholder="$t('forms.searchNameOrEmail')" v-model="filters.search" @input="onSearchInput"/>
                                </b-form-group>
                            </div>
                            <div class="col-lg-2 my-auto">
                                <b-button variant="light" class="mr-2" @click="clearFilters">{{ $t('forms.clearFilters') }}</b-button>
                            </div>
                        </div>
                        <b-button variant="success" class="mb-4" :disabled="exporting" @click="exportConsents">{{ $t('forms.exportXlsx') }}</b-button>
                        <b-table striped hover :items="items" :fields="fields" @row-clicked="openDetails" class="clickable"></b-table>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <b-pagination
                v-model="pageNr"
                :total-rows="allPages"
                per-page="1"
                first-number
                last-number
                @change="handlePageChange"
                align="right">
            </b-pagination>
        </div>
    </section>
</template>

<script>
    import moment from 'moment'
    import customerConsentList, {ORDER_TYPE_PAID, ORDER_TYPE_REQUEST, orderTypeLabel} from '../../../mixins/CustomerConsentList'

    export default {
        name: 'CustomerConsentList',
        // Stan filtrów, pobieranie strony i eksport siedzą w mixinie — patrz
        // komentarz w src/mixins/CustomerConsentList.js.
        mixins: [customerConsentList],
        data() {
            return {
                orderTypeOptions: [
                    {value: '', text: this.$t('forms.orderTypeAll')},
                    {value: ORDER_TYPE_REQUEST, text: this.$t('forms.orderTypeRequest')},
                    {value: ORDER_TYPE_PAID, text: this.$t('forms.orderTypePaid')}
                ],
                // Widok pokazuje wyłącznie zakres danych objęty zgodą: id, imię,
                // adres email, typ zamówienia i datę wyrażenia zgody.
                fields: [
                    {
                        key: 'id',
                        label: 'ID',
                        sortable: true,
                        thStyle: 'width: 75px;'
                    },
                    {
                        key: 'name',
                        label: this.$t('forms.firstname'),
                        sortable: true
                    },
                    {
                        key: 'email',
                        label: this.$t('forms.email'),
                        sortable: true
                    },
                    {
                        key: 'orderType',
                        label: this.$t('forms.orderType'),
                        sortable: true,
                        formatter: value => {
                            return orderTypeLabel(value, key => this.$t(key))
                        }
                    },
                    {
                        key: 'createdDate',
                        label: this.$t('forms.consentDate'),
                        sortable: true,
                        formatter: value => {
                            return moment(value).format('DD.MM.YYYY, HH:mm');
                        }
                    }
                ]
            }
        }
    }
</script>

<style scoped>
    .clickable /deep/ tbody td {
        cursor: pointer;
    }

</style>
